const formatEventDates = (dateString, timezoneLabel = "") => {
  if (!dateString) {
    return {
      dateString: "",
      fullDate: "",
    };
  }

  const [rawDate = "", rawTime = ""] = String(dateString).split("|");
  const datePart = rawDate.trim();
  const timePart = rawTime.trim().split(" ")[0];

  const fullDate = new Date(`${datePart} ${timePart}`);

  if (Number.isNaN(fullDate.getTime())) {
    return {
      dateString: datePart,
      fullDate: [datePart, timePart, timezoneLabel].filter(Boolean).join(" | "),
    };
  }

  const shortDate = fullDate.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

  const longDate = fullDate.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  const formattedTime = fullDate.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return {
    dateString: shortDate,
    fullDate: `${longDate} | ${formattedTime}${
      timezoneLabel ? ` (${timezoneLabel})` : ""
    }`,
  };
};

export default formatEventDates;
